import * as React from 'react';

import BodyWrapper from '../layout/BodyWrapper';
import PrimaryHeader from '../styleguide/PrimaryHeader';
import styles from './AllProducts.module.css';

const ProductDetail = ({product}) => {
  
  const productData = !!product.Id;

  // Delete empty object members:
  if (productData) {
    Object.keys(product).forEach((key) => (
        product[key] == null || 
        product[key] === "" ||
        product[key] === '0001-01-01T00:00:00+00:00'
      ) && delete product[key]);
  } 

  return (
    <BodyWrapper>
      { productData 
        ? <>
            <PrimaryHeader isCentered text={product.Name} />
            <table>
              <tbody>  
                { Object.keys(product).map ((key) => {
                    return (
                      <tr key={key}> 
                        <th className={styles.detailRowHdr} align="left">
                          {key}  
                        </th>
                        <td align="left">
                          { product[key].toString()}  
                        </td>              
                      </tr>
                    )
                  })
                }
              </tbody>  
            </table>
          </>
        : null
      }
    </BodyWrapper>
  )
}

export default  ProductDetail;